// Shown where the customer's tier does not include the Qlik Cloud apps
// (ENTRAID-295). It replaces a dead-end "not included" sentence with a way
// forward: a plan change on AWS Marketplace (only when a listing URL is
// configured) and an always-available request link.
export const QLIK_APPS_REQUEST_MAILTO =
  'mailto:support@ipc-global.com?subject=onGuard%20for%20Entra%20ID%3A%20Qlik%20Cloud%20apps%20request';

const QLIK_FEATURE = Object.freeze({
  testId: 'qlik-upsell-card',
  title: 'Qlik Cloud apps are not part of your current plan',
  body: 'Upgrade your plan on AWS Marketplace to get the onGuard Qlik Cloud apps, ready-made dashboards for this data.',
  requestLabel: 'Request Qlik Cloud apps',
  mailto: QLIK_APPS_REQUEST_MAILTO,
});

/** The same card for Compliance reports (ENTRAID-307). */
export const COMPLIANCE_FEATURE = Object.freeze({
  testId: 'compliance-upsell-card',
  title: 'Compliance readiness reports are not part of your current plan',
  body: 'Upgrade your plan on AWS Marketplace to generate Entra ID compliance readiness reports with readiness against an industry security benchmark and NIST SP 800-53 control mappings.',
  requestLabel: 'Request compliance readiness reports',
  mailto: 'mailto:support@ipc-global.com?subject=onGuard%20for%20Entra%20ID%3A%20Compliance%20Readiness%20reports%20request',
});

export default function QlikUpsellCard({ marketplaceListingUrl, feature }) {
  const f = feature ?? QLIK_FEATURE;
  return (
    <div data-testid={f.testId}>
      <h3 className="text-sm font-semibold text-ipc-primary">
        {f.title}
      </h3>
      <p className="text-sm text-slate-700 mt-1">
        {f.body}
      </p>
      <div className="flex flex-wrap items-center gap-4 mt-3">
        {marketplaceListingUrl && (
          <a
            className="text-sm px-4 py-2 rounded-md bg-ipc-light text-white hover:bg-ipc-primary transition-colors"
            href={marketplaceListingUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Change plan on AWS Marketplace
          </a>
        )}
        <a className="text-sm text-ipc-light hover:text-ipc-primary underline" href={f.mailto}>
          {f.requestLabel}
        </a>
      </div>
    </div>
  );
}
